import React, { useRef } from 'react'
import emailjs from '@emailjs/browser';

import i3 from "../img/img2.png";


export default function Contact() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();


    emailjs.sendForm('service_20w9xpc', 'template_mc9xbjk', form.current, 'Xy5VzFba8DCbdGPZM')
      .then((result) => {
          console.log(result.text);
          alert("Message send successfully");
          e.target.reset();
      }, (error) => {
          alert(error.text);
      });
  };

  return (
    <div>
       <div
        className="max-w-screeen-lg mx-auto grid grid-rows md:grid-flow-col 
         items-center justify-center h-full  md:flex-row "
      >
        <div className="col-span-1 md:col-span-1">
          <img
            //className="object-contain h-12 w-20 pt-2 mx-auto w-2/3 md:w-full"
            src={i3}
            alt="IMG2"
            className="mx-auto w-2/3 md:w-full"
          />
        </div>

        <div className="flex flex-col justify-center h-full px-10 mx-10 ">
          <h2 className="text-4xl sm:text-4xl font-bold ">Contact me</h2>
          <h1 className="py-4 max-w-md">
            Creativity is the heartbeat of innovation, the fuel that ignites
            inspiration. Let's ignite together and create a symphony of
            imagination.
          </h1>

          <form ref={form} onSubmit={sendEmail}>
            <div class="mb-6">
              <input
                type="email"
                id="user_email"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 bg-white dark:border-black dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                placeholder="Email"
                name="user_email"
                required
              />
            </div>
            <div class="mb-6">
              <input
                type="text"
                id="user_name"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 bg-white dark:border-black dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                placeholder="Name"
                name="user_name"
                required
              />
            </div>
            <div class="mb-6">
              <textarea
                id="message"
                rows="4"
                class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 bg-white dark:border-black dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                placeholder="Message"
                name="message" 
                required
              />
            </div>
            <div>
            <button
              type="submit"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Send
            </button>
          </div>
          </form>

          
        </div>
      </div>
    </div>
  )
}
